module.exports = __webpack_public_path__ + "img/bv-app-store.09ad6ad9.png";